import axios from 'axios';

export const isUnauthorizedError = (error: unknown) =>
  axios.isAxiosError(error) && error.response && error.response.status === 401;

export const HandleUnauthorizedError = (error: unknown, errorHandler: () => void) => {
  if (isUnauthorizedError(error)) {
    errorHandler();
  } else {
    throw error;
  }
};
